import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { collect } from 'collect.js';
import { toast } from 'react-toastify';
import MenuManager from '../../services/api/MenuManager';
import CategoryCard from '../../components/cards/CategoryCard';
import ModifierGroupCard from '../../components/cards/ModifierGroupCard';
import { Spin, Tabs } from 'antd';
import Layout from '../../components/layout/Layout';

export default function MenuView() {
  const { t } = useTranslation(null, { keyPrefix: 'Views:Menu' });

  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [modifierGroups, setModifierGroups] = useState([]);

  const [collapsedCategories, setCollapsedCategories] = useState([]);
  const [collapsedModifierGroups, setCollapsedModifierGroups] = useState([]);

  useEffect(() => {
    Promise.all([
      requestCategories().then((data) => setCollapsedCategories(collect(data).pluck('id').toArray())),
      requestModifierGroups().then((data) => setCollapsedModifierGroups(collect(data).pluck('id').toArray())),
    ]).finally(() => setLoading(false));
  }, []);

  const requestCategories = async () => {
    const { data, success } = await MenuManager.getCategories();

    if (!success) {
      return toast.error(t('toasts.failed_to_load_data'));
    }

    setCategories(data.data);

    return data.data;
  };

  const requestModifierGroups = async () => {
    const { data, success } = await MenuManager.getModifierGroups();

    if (!success) {
      return toast.error(t('toasts.failed_to_load_data'));
    }

    setModifierGroups(data.data);

    return data.data;
  };

  const toggleCategory = (category) => {
    if (collect(collapsedCategories).contains(category.id)) {
      return setCollapsedCategories((current) =>
        collect(current)
          .reject((item) => item === category.id)
          .toArray(),
      );
    }

    return setCollapsedCategories((current) => [...current, category.id]);
  };

  const toggleModifierGroup = (modifierGroup) => {
    if (collect(collapsedModifierGroups).contains(modifierGroup.id)) {
      return setCollapsedModifierGroups((current) =>
        collect(current)
          .reject((item) => item === modifierGroup.id)
          .toArray(),
      );
    }

    return setCollapsedModifierGroups((current) => [...current, modifierGroup.id]);
  };

  return (
    <Layout.Page>
      {loading && <Spin fullscreen={true} />}
      <Tabs
        defaultActiveKey="menu"
        items={[
          {
            key: 'menu',
            label: t('tabs.menu'),
            children: (
              <div className="space-y-md">
                {categories.map((item) => (
                  <CategoryCard
                    category={item}
                    toggle={() => toggleCategory(item)}
                    isCollapsed={collect(collapsedCategories).contains(item.id)}
                    onProductChange={requestCategories}
                    key={item.id}
                  />
                ))}
              </div>
            ),
          },
          {
            key: 'modifier_groups',
            label: t('tabs.modifier_groups'),
            children: (
              <div className="space-y-md">
                {modifierGroups.map((item) => (
                  <ModifierGroupCard
                    data={item}
                    toggle={() => toggleModifierGroup(item)}
                    isCollapsed={collect(collapsedModifierGroups).contains(item.id)}
                    onModifierChange={requestModifierGroups}
                    key={item.id}
                  />
                ))}
              </div>
            ),
          },
        ]}
      />
    </Layout.Page>
  );
}
